// extracted by mini-css-extract-plugin
export default {"root":"JournalPage_root__bUgC8","root_date":"JournalPage_root_date__s6DUi","root_content":"JournalPage_root_content__ZyTwY"};